import React from 'react'
import { Container } from './Footer.styles'
import { Button } from '@welbe/web-design-system'
import { useWindowSize } from 'utils/useWindowSize'
import { DeleteAccountStep } from 'Views/DeleteAccount/DeleteAccount.types'

type FooterProps = {
	agreed: boolean
	invalid: boolean
	loading: boolean
	currentStep: DeleteAccountStep
	onPrev: () => void
	onNext: () => void
}

export const Footer = ({
	agreed,
	invalid,
	loading,
	currentStep,
	onPrev,
	onNext,
}: FooterProps) => {
	const { width } = useWindowSize()
	const isMobile = width < 648

	if (currentStep === 'finished') {
		return null
	}

	return (
		<Container>
			<Button
				width={isMobile ? undefined : '150px'}
				variant="secondary"
				onClick={onPrev}
				disabled={loading || currentStep === 'deleteForm'}
				className="cancel-button"
			>
				Cancelar
			</Button>
			<Button
				width={isMobile ? undefined : '150px'}
				onClick={onNext}
				loading={loading}
				disabled={!agreed || invalid}
			>
				{currentStep === 'codeVerify' ? 'Eliminar cuenta' : 'Continuar'}
			</Button>
		</Container>
	)
}
